// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/EditableLabel/styles.scss
// module id = 803
// module chunks = 0